module.exports = __webpack_public_path__ + "img/img2.639e65fd.png";